// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2QNi8","errors":"Errors_errors__6n-ok"};